/*
 * NJ: merge the selected variant's two metafields into Breeze's existing
 * localStorage "breeze_cart_attributes" object (a flat JSON object of string
 * values, which the Breeze SDK copies into its cart attributes at checkout).
 *
 * Only these two keys are ever written or removed:
 *   custom.estimated_time_of_dispatch
 *   custom.pre_order_status
 * Every other key already in breeze_cart_attributes is preserved as-is.
 * Isolated: deleting this file and its snippet leaves the theme and Breeze unchanged.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'breeze_cart_attributes';
  var ETD_KEY = 'custom.estimated_time_of_dispatch';
  var STATUS_KEY = 'custom.pre_order_status';

  var dataEl = document.querySelector('script[data-nj-breeze-variant-attributes]');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent) || {};
  } catch (e) {
    return;
  }

  var section = dataEl.closest('.shopify-section') || document;

  function selectedVariantId() {
    var input = section.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    return fromUrl ? String(fromUrl) : '';
  }

  function sync() {
    var variant = variants[selectedVariantId()];
    if (!variant) return;

    var attrs = {};
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        /* Unrecognised existing value: leave it alone rather than risk overwriting Breeze data. */
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return;
        attrs = parsed;
      }
    } catch (e) {
      return;
    }

    /* Set when the variant has a value; otherwise remove only our own key so no stale value from a previous variant remains. */
    if (variant.estimatedTimeOfDispatch) attrs[ETD_KEY] = variant.estimatedTimeOfDispatch;
    else delete attrs[ETD_KEY];
    if (variant.preOrderStatus) attrs[STATUS_KEY] = variant.preOrderStatus;
    else delete attrs[STATUS_KEY];

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attrs));
    } catch (e) {}
  }

  sync();

  /* Theme variant changes update the hidden [name="id"] input and fire "change"; run after the theme's own handlers. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') setTimeout(sync, 0);
  });
  ['variant:changed', 'variantChange', 'variant-change'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(sync, 0); });
  });
  window.addEventListener('pageshow', sync);
  /* Re-sync just before any click (e.g. Breeze checkout). Passive: never stops or alters the click. */
  document.addEventListener('click', sync, true);
})();
